import {
	SET_FORM_STATE,
	GET_DUMPS_UPDATE
} from '../actions/RetAuditActions.js';

const initialState = {
	dumps: [],
	formState:
	{
		isValid: false,
		values: {},
		touched: {},
		errors: {}
	},
};

const RETEnablingChecksReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: { ...state.formState, ...action.formState }
						};
					}
					case GET_DUMPS_UPDATE: {
						return {
							...state,
							dumps: action.dumpsUpdate
						};
					}
					default: {
						return state;
					}
	}
};

export default RETEnablingChecksReducer;
